import {Routes} from '@angular/router';

export const shipmentManagementRoutes: Routes = [
  {
    path: 'shipmentManagement',
    data: { title: '快递发货管理' },
    children: [
      {
        path: '',
        loadComponent: () => import('./shipment-management.component').then(m => m.ShipmentManagementComponent),
        data: { title: '快递发货管理' },
      },
      {
        path: 'addShipmentDetail',
        loadComponent: () => import('./add-shipment-detail/add-shipment-detail.component').then(m => m.AddShipmentDetailComponent),
        data: { title: '添加快递发货' },
      },
      {
        path: 'shipmentDetail/:shipmentOrderId',
        loadComponent: () => import('./shipment-detail/shipment-detail.component').then(m => m.ShipmentDetailComponent),
        data: { title: '快递发货明细' },
      },
    ]
  },
];
